<template>
    <div>
        <div class='btnsBox'>
            <el-button type="primary" @click="add">新增</el-button>
        </div>
        <el-table
            ref="table"
            border
            :data="tableData"
            style="width: 100%"
        >
            <el-table-column type="index" label="序号" width="50">
                <template slot-scope="scope">{{scope.$index + 1}}</template>
            </el-table-column>
            <el-table-column prop="mc" label="登录角色名称"  width="180"></el-table-column>
            <el-table-column prop="dm" label="登录角色代码"  width="180"></el-table-column>
            <el-table-column prop="rolestr" label="登录方式"  min-width="170"></el-table-column>
            <el-table-column  label="操作" width="120" fixed='right'>
                <template slot-scope="scope">
                    <el-button type="text"  @click='edit(scope.row)'>编辑</el-button>
                    <el-button type="text"  @click='del(scope.row)'>删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 新增编辑 -->
        <el-dialog :title='lx+"角色"' :visible.sync="dialogVisible" width='700px' lock-scroll :close-on-click-modal="false" >
            <el-form :model="form" ref='form' label-width="120px" :rules="formRules">
                <el-form-item label="登录角色名称" prop='mc'>
                    <el-input v-model="form.mc"></el-input>
                </el-form-item>
                <el-form-item label="登录角色代码" prop='dm'>
                    <el-input v-model="form.dm"></el-input>
                </el-form-item>
                <el-form-item label="登录方式" prop='rolestr'>
                    <el-checkbox-group v-model="form.rolestr">
                        <el-checkbox  v-for="(item,index) in fsOptions"  :key="index" :label='item'></el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
            <div class='btnBox'>
                <el-button type="primary" @click='saveForm("form")'>确定</el-button>
                <el-button type="primary" @click='resetForm("form")'>重置</el-button>
                <el-button type="primary" @click='cancelForm("form")'>取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name:'',
    props:[
        'adminLx'
    ],
    data(){
        return{
            tableData:[],
            dialogVisible:false,
            lx:'新增',
            form:{
                mc:'',
                dm:'',
                rolestr:[]
            },
            formRules:{
                mc:[{required:true,trigger:'blur',message:'必填项'}],
                dm:[{required:true,trigger:'blur',message:'必填项'}],
                rolestr:[{required:true,trigger:'change',message:'必填项'}],
            },
            fsOptions:['CA登录','账号登录','扫码登录']
        }
    },
    methods:{
        getData(){
            let para={
                lx:this.adminLx
            }
            this.$api.getLoginRole(para).then(res=>{
                if(res.data.meta.success){
                    this.tableData=res.data.data.list
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
            }).catch(()=>{})
        },
        //新增
        add(){
            this.dialogVisible=true;
            this.lx='新增';
            this.form={
                mc:'',
                dm:'',
                rolestr:[]
            }
        },
        //编辑
        edit(row){
            this.dialogVisible=true;
            this.lx='编辑';
            var obj=Object.assign({},row)
            obj.rolestr=obj.rolestr.split(',')
            this.form=obj
        },
        saveForm(formName){
            this.$refs[formName].validate((valid)=>{
                if(valid){
                    let para=this.form;
                        para.lx=this.adminLx
                        para.rolestr=para.rolestr.join(',')
                        this.$api.saveLoginRole(para).then(res=>{
                            if(res.data.meta.success){
                                this.$message({
                                    type:'success',
                                    message:'保存成功！'
                                })
                                this.dialogVisible=false;
                                this.getData();
                            }else{
                                this.$message({
                                    type:'error',
                                    message:res.data.meta.message
                                })
                            }
                        }).catch(()=>{})
                }else{
                    return false;
                }
            })
        },
        resetForm(formName){
            this.$refs[formName].resetFields();
        },
        cancelForm(formName){
            this.$refs[formName].resetFields();
            this.dialogVisible=false
        },
        //删除
        del(row){
            let text=''
            let para={
                id:row.id
            }
            this.$confirm('确定要删除当前的角色吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.delLoginRole(para).then(res=>{
                    if(res.data.meta.success){
                        this.$message({
                            type:'success',
                            message:'删除成功！'
                        })
                        this.dialogVisible=false;
                        this.getData();
                    }else{
                        this.$message({
                            type:'error',
                            message:res.data.meta.message
                        })
                    }
                }).catch(()=>{})
                
            }).catch(() => {
                      
            });
        },
    },
    mounted(){
        this.getData();
    }
}
</script>  
<style lang="less" scoped>

</style>